export enum Color {
  PRIMARY = "primary"
}
